import { SurveyV2 } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum SurveyEventTypes {
  SURVEYS_ASSIGNED = '[Survey] Surveys Assigned',
  PHASE_COMPLETED = '[Survey] Survey Phase Completed',
  QUESTION_COMPLETED = '[Survey] Survey Question Completed',
  SURVEY_UPDATED = '[Survey] Survey Summary Updated',
}

/**
 * Payloads
 */
export interface SurveyEventPayload {
  surveys: SurveyV2.AssignedSurveyDto[];
}

/**
 * Events
 */
export class SurveyAssignedEvent {
  readonly type = SurveyEventTypes.SURVEYS_ASSIGNED;

  constructor(public payload: SurveyEventPayload) {}
}

export class SurveyPhaseCompletedEvent {
  readonly type = SurveyEventTypes.PHASE_COMPLETED;

  constructor(public payload: SurveyEventPayload) {}
}

export class SurveyQuestionCompletedEvent {
  readonly type = SurveyEventTypes.QUESTION_COMPLETED;

  constructor(public payload: SurveyEventPayload) {}
}

export class SurveyUpdatedEvent {
  readonly type = SurveyEventTypes.SURVEY_UPDATED;

  constructor(public payload: SurveyEventPayload) {}
}
